<template>
  <div class="page">
    <van-swipe v-if="imgList && imgList.length" :autoplay="3000" indicator-color="white" :show-indicators="false"  class="swiper">
      <van-swipe-item v-for="item in imgList" :key="item.imageUrl" @click="linkPage(item)">
        <div class="swiperItem">
          <!-- <img src="@/assets/coupon-imgs/banner.png" object-fit="fill" /> -->
          <van-image class="banner" :src="item.imageUrl" height="133" radius="8"></van-image>
        </div>
      </van-swipe-item>
    </van-swipe>
    <div>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="refresh-div" :style="{height:imgList&&imgList.length?'auto':'100vh'}">
        <van-list
          v-model="loading"
          :finished="finish"
          finished-text="没有更多了"
          @load="loadMore"
          v-if="list && list.length"
        >
        <!-- <van-radio-group v-model="radioCheck">
          <template v-for="item in list">
            <coupon-item :item="item" :key="item.id" @onUse="useCoupon" @onGet="getCoupon" :radioValue.sync="radioCheck"></coupon-item>
          </template>
        </van-radio-group> -->
          <template v-for="item in list">
            <coupon-item :item="item" :key="item.id" @onUse="useCoupon" @onGet="getCoupon" :radioValue.sync="radioCheck"></coupon-item>
          </template>
        </van-list>
        <div v-else class="flex flex-row-center flex-col-center m-t-153">
          <no-data desc="暂无优惠券" showType="coupon" imgWidth="5.6rem" imgHeight="5.6rem" imgClass="coupon-no-data"></no-data>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import couponItem from "@/components/couponItem";
import NoData from '@/components/noData'
export default {
  components: { couponItem ,NoData},
  data() {
    return {
      loading: false,
      finish: false,
      radioCheck:'',
      page:1,
      pageSize:10,
      total:0,
      list: [],
      refreshing:false,
      imgList:[]
    };
  },
  mounted(){
    this.getBannbers()
    this.getList()
    this.$nextTick(()=>{
      this.finish = true
    })
  },
  methods: {
    /**
     * @description 获取banner列表
     */
    getBannbers:function(){
      this.$service.couponBanner().then(res=>{
        // console.log(res)
        if(res.status == 200 && res.result.length){
          this.imgList = res.result
        }
      })
    },
    /**
     * @description 加载更多
     */
    loadMore: function () {
      if(this.total >= this.list.length) return
      this.page++
      this.getList(false,true)
    },
    /**
     * @description 刷新列表
     */
    onRefresh:function(){
      this.getList(true)
    },
    /**
     * @description 获取优惠券列表
     */
    getList:function(isRefresh,isMore){
      if(isRefresh) {
        this.page = 1
        this.refreshing = true
      }
      const param = {
        page:this.page,
        pageSize:this.pageSize
      }
      this.$service.centerList(param).then(res=>{
        // console.log(res)
        this.total = res.result.total
        const old = this.list
        if(isMore) this.list = [...old,...res.result.list]
        else this.list = res.result.list
        if(isRefresh) this.refreshing = false
      })
    },
    /**
     * @description 领取优惠券
     */
    getCoupon: function (couponInfoId) {
      // console.log("get", couponInfoId);
      this.$toast.loading()
      this.sendStatics('event_take_ticket_click',{currentUrl:37,module:93})
      this.$service.getCoupon({couponInfoId:couponInfoId}).then(res=>{
        // console.log(res)
        this.$toast.clear()
        if(res.result.status != 200){
          this.$toast(res.result.message)
        }else{
          this.$toast.success('领取成功')
          this.$nextTick(()=>{
            this.getList()
          })
        }
      })
    },
    /**
     * @description 使用优惠券
     */
    useCoupon: function (item) {
      // console.log("use", item);
      // this.$navigateTo('member',{},false,'switchTab')
      this.$reLaunch("member","")
    },
    /**
     * @description 跳转到外部链接
     */
    linkPage:function(item){
      if(item.pageUrl && item.pageUrl !== "anchor"){
        if(item.pageUrl.indexOf("/pages") === 0){
          let arr = item.pageUrl.split("/");
          let uri = "/" + arr[3]
          this.$router.push({path: uri})
        }else{
          this.$router.push({path: '/outerPage',query:{pageUrl:item.pageUrl}})
        }
        this.$service.getStatisCommon("evn_close_page",{});
      }
      return
    },
  },
};
</script>
<style lang="less">
.page {
  background: #f4f4f4;
  min-height: 100vh;
  .content {
    padding: 10px;
  }
  .swiperItem {
    padding: 0 10px;
  }
  .shadow2 {
    box-shadow: 0px -3px 4px 0px rgba(245, 159, 82, 0.55);
  }
  .swiper{
    height: 133px;
  }
  .banner{
    width: 100%;
    height: 100%;
  }
  .refresh-div{
    min-height: calc(100vh - 133px);
  }
}
.m-t-153{
  margin-top: 121px;
}
</style>